
import { grey } from '@material-ui/core/colors';

export default (theme) => ({
  listContainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: grey[100],
  },
});
